import { Injectable } from '@angular/core';
import { IButton, ITableButtons } from '@app/modules/table/table.interface';

/**
 * Сервис заменяет кнопки Создать/Редактировать в таблице в зависимости от выбранных элементов
 */
@Injectable()
export class TableReorderButtonsService {
    private removedAddButton: IButton | null = null;

    /**
     * Смена кнопок
     * @param buttons
     * @param selectionCount
     */
    public reorderButtons(buttons: ITableButtons, selectionCount: number) {
        let editButton: IButton | null = null;

        // Поиск и удаление кнопок по всем массивам
        if (buttons.global === undefined) {
            buttons.global = [];
        }
        if (buttons.globalMenu === undefined) {
            buttons.globalMenu = [];
        }
        for (const key in buttons) {
            if (Array.isArray(buttons[key])) {
                if (!editButton) {
                    editButton = this.findAndRemoveButton(buttons[key], 'edit');
                }
                // Удаляем кнопку "add", только если selectionCount больше 0
                if (!this.removedAddButton && selectionCount > 0) {
                    this.removedAddButton = this.findAndRemoveButton(buttons[key], 'add');
                }
                if (editButton && this.removedAddButton) {
                    break;
                }
            }
        }

        // Добавление кнопок по условию
        if (selectionCount >= 1) {
            if (editButton) {
                buttons.global.push(editButton);
            }
        } else {
            // Восстанавливаем обработанную кнопку "add", если selectionCount 0
            if (this.removedAddButton) {
                buttons.global.push(this.removedAddButton);
                this.removedAddButton = null;
            }
            if (editButton) {
                buttons.globalMenu.unshift(editButton);
            }
        }

        return buttons;
    }

    /**
     * Поиск и удаление кнопок в массивах
     * @param buttonArray
     * @param clickType
     */
    private findAndRemoveButton = (buttonArray: IButton[], clickType: string): IButton | null => {
        const index = buttonArray.findIndex((button: IButton) => button.click === clickType);
        if (index !== -1) {
            return buttonArray.splice(index, 1)[0];
        }
        return null;
    };
}
